module.exports = __webpack_public_path__ + "static/media/FSF_logo.e64f4b4e.svg";